import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import DOMPurify from 'dompurify';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import useNavProps from '../../hooks/useNavProps';
import CompetitionToolbar from './CompetitionToolbar';
import CompetitionUtils from '../../utilities/CompetitionUtils';
import CompetitionNationalViewComponent from '../../components/competition/CompetitionNationalViewComponent';
import CompetitionJobViewComponent from '../../components/competition/CompetitionJobViewComponent';
import ApiService from '../../service/ApiService';
import MoveCompetitionStatusForward from '../../components/competition/MoveCompetitionStatusForward';

const CompetitionView = () => {
    const [competition, setCompetition] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    const { competitionIdParam } = useParams();

    const { setNavPropsValue } = useNavProps();

    useEffect(() => {
        setIsLoading(true);
        const getCompetition = async () => {
            await competitionService.getCompetition(competitionIdParam)
                .then(async (competitionData) => {
                    // console.log(competitionData);
                    setCompetition(competitionData);

                    setNavPropsValue('competition-job', competitionData.id, competitionData.name)

                    setIsLoading(false);
                })
                .catch((error) => toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getCompetition();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [competitionService, competitionIdParam]);

    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        // set all elements owning target to target=_blank
        if ('target' in node) {
            node.setAttribute('target', '_blank');
            node.setAttribute('rel', 'noopener');
        }
    });

    const refresh = async (_competition) => {
        if (_competition) {
            setCompetition(_competition);
        }
    };

    if (isLoading) {
        return (
            <div className="w-full flex align-items-center">
                <Toast ref={toast} />
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <div className="grid h-full">
                    <div className="col-12">
                        <div className="card h-full">
                            <CompetitionToolbar competition={competition} code="DETAIL" />

                            {CompetitionUtils.isNationalCompetition(competition?.type) &&
                                <CompetitionNationalViewComponent competition={competition} refresh={refresh} />
                            }

                            {CompetitionUtils.isJobCompetition(competition?.type) &&
                                <CompetitionJobViewComponent competition={competition} refresh={refresh} />
                            }

                            {!ApiService.getIsProduction() &&
                                <MoveCompetitionStatusForward competition={competition} />
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default CompetitionView;
